export default __webpack_public_path__ + "static/mixworld_background-75a2fc0228758fcebcea9d2f66031464.webp";